"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getKYCPopupSource = void 0;
var _kycReplyRestriction = require("../Constants/kycReplyRestriction");
var getKYCPopupSource = exports.getKYCPopupSource = function getKYCPopupSource(_ref) {
  var pathname = _ref.pathname;
  if (pathname.includes(_kycReplyRestriction.TRACKING_PATH.ADPV)) {
    return _kycReplyRestriction.TRACKING_PAGES.ADPAGE;
  }
  return _kycReplyRestriction.TRACKING_PAGES.HP;
};